import type { VoidFunctionComponent } from 'react';

import { Category, IssueScopeKind } from '../../../../../shared/issuesV2';
import IssuesSection from '../../../shared/settings/SettingsPageIssueSection';
import Section from '../../../shared/settings/SettingsPageSection';

import type { IssueSettingsProps } from './types';

/**
 * ProjectLicensingIssuesSettings
 */
const ProjectLicensingIssuesSettings: VoidFunctionComponent<IssueSettingsProps> = ({
  isSnippetScanningEnabled,
  onToggleSnippetScanning,
  isVendoredScanningEnabled,
  onToggleVendoredScanning,
  ...issuesSectionProps
}) => {
  return (
    <Section>
      <Section.Left heading="Licensing">
        <Section.Paragraph>Configuration for licensing issues on this project.</Section.Paragraph>
      </Section.Left>
      <Section.Right>
        <IssuesSection
          category={Category.Licensing}
          scopeType={IssueScopeKind.Project}
          isSnippetScanningEnabled={isSnippetScanningEnabled}
          onToggleSnippetScanning={onToggleSnippetScanning}
          isVendoredScanningEnabled={isVendoredScanningEnabled}
          onToggleVendoredScanning={onToggleVendoredScanning}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...issuesSectionProps}
        />
      </Section.Right>
    </Section>
  );
};

export default ProjectLicensingIssuesSettings;
